export const HTTP_STATUS_OK = 'Success'; // 200
export const HTTP_STATUS_TOKEN_EXPIRE = 'Token expired'; // 401
export const HTTP_STATUS_BAD_REQUEST = 'Bad request'; // 400
export const HTTP_STATUS_NOT_FOUND = 'Not found'; // 404
export const HTTP_STATUS_CONFLICT = 'Conflict error'; // 409
export const HTTP_STATUS_INTERNAL_SERVER = 'Internal server error'; // 500
export const ACCESS_TOKEN_KEY = 'BizB2B_Token_Key';
export const BASE_URL = 'https://eshopapi.pacificeshop.com';
export const BASE_AUTH_URL = 'https://eshopauth.pacificeshop.com';
export const ReCAPTCHA_SECRET_KEY = '6LdgHSAlAAAAAP6XxRsmr5s4WMc7GWHUhQuUhh7K';
export const ReCAPTCHA_SITE_KEY = '6LdgHSAlAAAAAAttMlJhj2vyIwH6XiDPmmLvDLh7';
